/**
 * Portal ICAVI - Serviço de domínio: Logs do Sistema
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const sistemaLogsServiceMethods = {
    async listarLogsSistema(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.page)
                queryParams.append('page', String(params.page));
            const perPage = params.per_page ?? params.limit;
            if (perPage)
                queryParams.append('per_page', String(perPage));
            if (params.nivel)
                queryParams.append('nivel', params.nivel);
            if (params.modulo)
                queryParams.append('modulo', params.modulo);
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.usuario)
                queryParams.append('usuario', params.usuario);
            if (params.entidade_id)
                queryParams.append('entidade_id', params.entidade_id);
            if (params.acao)
                queryParams.append('acao', params.acao);
            if (params.sucesso && params.sucesso !== 'todos') {
                queryParams.append('sucesso', params.sucesso);
            }
            if (params.busca)
                queryParams.append('busca', params.busca);
            const url = `/api/sistema/logs${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar logs do sistema:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
};
